export class CRMView {

    id: number;
    dateDue: Date | null;
    title: string;
    problemDesc: string;
    reminderStatus: number;
    googleEventId: string | null;
    solution: string;
    creationDate: Date|null;
    lastActionDate: Date|null;
    status: string;
    category: string;
    bobexMemberName: string;
    lastBobexMemberName: string;
    bobexMemberId: number;
    statusId: number;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.dateDue = data?.dateDue ? new Date(data.dateDue) : null;
        this.title = data?.title ?? "";
        this.problemDesc = data?.problemDesc ?? "";
        this.reminderStatus = data?.reminderStatus ?? 0;
        this.googleEventId = data?.googleEventId ?? null;
        this.solution = data?.solution ?? "";
        this.creationDate = data?.creationDate ? new Date(data.creationDate) : null;
        this.lastActionDate = data?.lastActionDate ? new Date(data.lastActionDate) : null;
        this.status = data?.status ?? "";
        this.category = data?.category ?? "";
        this.bobexMemberName = data?.bobexMemberName ?? "";
        this.lastBobexMemberName = data?.lastBobexMemberName ?? "";
        this.bobexMemberId = data?.bobexMemberId ?? 0;
        this.statusId = data?.statusId ?? 0;
    }
}